import model from './model';
import { FeaturedCollectionsWidgetComponentIds as ComponentIds } from './config/constants';
import { Collection } from '@wix/ambassador-portfolio-collections-v1-collection/types';
import { Project } from '@wix/ambassador-portfolio-projects-v1-project/types';
import {
  getCollectionProjects,
  getCollectionsWithHidden,
} from '../../services/dataServices';
import { WarmupDataManager } from '../../utils/WarmupDataManager';
import { getCustomViewerHttpClient } from '../../utils/viewerUtils';
import _ from 'lodash';

export default model.createController((controllerParams) => {
  const { $w, $widget, flowAPI } = controllerParams;
  const { httpClient } = getCustomViewerHttpClient(flowAPI);
  const { isSSR } = flowAPI.environment;
  const shouldShowEmptyComponent = isSSR;

  let components: ReturnType<typeof getComponents>;
  let collections: Collection[] = [];
  let collectionProjects: Project[] = [];

  const warmupData = new WarmupDataManager(
    flowAPI.controllerConfig.wixCodeApi.window.warmupData,
    flowAPI.environment,
  );

  const getComponents = () => ({
    topContainer: $w(ComponentIds.Root),
    multiStateBoxWidget: $w(ComponentIds.MultiStateWidget),
  });

  const getArrayOfSelectedCollections = () => {
    let filteredCollections: Collection[] = [];
    const selectedCollectionIds = $widget.props.data.selectedCollections;
    if (!selectedCollectionIds) {
      return [collections[0]];
    } else {
      filteredCollections = collections.filter((collection: Collection) => {
        const isCollectionSelected = selectedCollectionIds.includes(
          collection.id,
        );
        return isCollectionSelected;
      });
    }
    // TODO:Find a solution for duplicate site and collection ids change
    const { selectedCollectionDataSample } = $widget.props.data;
    if (
      selectedCollectionIds.length > 0 &&
      filteredCollections.length === 0 &&
      !!selectedCollectionDataSample
    ) {
      const duplicatedCollections = collections.filter((collection) => {
        const { title, slug } = collection;
        const isInclude = _.find(selectedCollectionDataSample, { title, slug });
        return !!isInclude;
      });
      if (duplicatedCollections.length > 0) {
        filteredCollections = duplicatedCollections;
      }
    }
    return filteredCollections;
  };

  const initFeaturedWidgetData = async () => {
    const selectedCollectionsDataArray = getArrayOfSelectedCollections();
    if (selectedCollectionsDataArray.length === 1) {
      const selectedCollection = selectedCollectionsDataArray[0];
      const projectsInCollection = await warmupData.manageData(
        () =>
          getCollectionProjects(httpClient, selectedCollection.id as string),
        `${selectedCollection.id}-Projects`,
      );
      collectionProjects = projectsInCollection.map(
        (p) => p.project,
      ) as Project[];
    }
    components.multiStateBoxWidget.data = {
      collections: selectedCollectionsDataArray,
      collectionProjects,
    };
  };
  const initEmptyCollection = async () => {
    components.multiStateBoxWidget.data = { collections: [] };
  };
  const initFeaturedWidget = async () => {
    try {
      collections = await warmupData.manageData(
        () => getCollectionsWithHidden(httpClient),
        'featuredCollections',
      );
      await initFeaturedWidgetData();
    } catch (e: any) {
      flowAPI.reportError(e);
      console.error('Failed to init featured widget', e);
      if (shouldShowEmptyComponent) {
        await initEmptyCollection();
      }
    }
  };
  return {
    pageReady: async () => {
      components = getComponents();
      await initFeaturedWidget();
    },
    exports: {},
  };
});
